// extracted by mini-css-extract-plugin
export default {"container":"custom-table_container__g+G1a","scroll":"custom-table_scroll__N-4BA","pagination":"custom-table_pagination__6DRD8"};